(function () {
  const CONFIG = {
    priceTypeExceptions: [6, 9, 19, 102, 157, 198, 204, 217, 246, 255, 273, 394, 452, 453, 455, 546, 548, 642],
  };
  let selectedPriceTypes = [];
  /**
   * Updates the selectedPriceTypes array by filtering out any
   * seat selections that are no longer selected in the UI.
   * This function should be called whenever there is a change
   * in seat selection to ensure that the booking fee is applied
   * correctly based on the current selections.
   * It retrieves all currently selected seats from the DOM, extracts
   * their seat IDs, and then filters the selectedPriceTypes array to
   * only include those that correspond to the currently selected seats.
   * This is important for scenarios where a user may select a seat,
   * choose a price type, and then deselect the seat, ensuring that
   * the booking fee is not applied to deselected seats.
   */
  function updateSelectedPriceTypes() {
    const selectedSeats = document.querySelectorAll(
      ".tn-syos-seat-map__seat--selected",
    );
    const selectedSeatIds = Array.from(selectedSeats).map((seat) => {
      return parseInt(seat.dataset.tnSeatId);
    });
    selectedPriceTypes = selectedPriceTypes.filter((selection) =>
      selectedSeatIds.includes(selection.seatId),
    );
  }
  /**
   * Attaches click event listeners to price type buttons in the seat selection modal.
   * When a price type button is clicked, it captures the associated seat ID and price type ID,
   * and updates the selectedPriceTypes array with this information. This allows the system
   * to keep track of which price types are selected for which seats, which is essential for
   * determining whether booking fees should be applied based on the user's selections.
   */
  function listenForSeatSelection() {
    const prices = document.querySelectorAll(
      ".tn-syos-seat-info__price-type--button",
    );
    Array.from(prices).forEach((btn) => {
      btn.addEventListener("click", (event) => {
        const seatId = parseInt(
          document
            .querySelector(".tn-syos-seat-info__header")
            .children[0].id.replace("tn-syos-seat-info-heading-", ""),
        );
        const priceTypeId = parseInt(event.currentTarget.dataset.priceTypeId);
        selectedPriceTypes.push({ seatId, priceTypeId });
      });
    });
  }
  function currentModeOfSale() {
    for (const obj of window.dataLayer) {
      if (obj.hasOwnProperty("session")) {
        return obj.session.modeOfSale;
      }
    }
    return 3;
  }
  function isPage(pathname) {
    return window.location.pathname.match(pathname) !== null;
  }
  function isFeeApplicable(message) {
    const el = document.querySelector(".tn-utility-nav-cart-link__quantity-badge");
    const basketQuantity = Number(el?.textContent?.trim() || 0);
    return message.modesOfSale.includes(currentModeOfSale()) && basketQuantity <= 0;
  }
  function availablePricesAreExempt() {
    try {
      const priceTypeIds = Array.from(
        document.querySelectorAll(".tn-syos-seat-info__price-type--button"),
      ).map((btn) => parseInt(btn.dataset.priceTypeId));
      for (const priceTypeId of priceTypeIds) {
        if (!CONFIG.priceTypeExceptions.includes(priceTypeId)) {
          return false;
        }
      }
      return true;
    } catch (error) {
      console.error("Error checking price type exceptions:", error);
      return false;
    }
  }
  function selectedPriceTypesAreExempt() {
    if (selectedPriceTypes.length === 0) return false;
    for (const selection of selectedPriceTypes) {
      if (!CONFIG.priceTypeExceptions.includes(selection.priceTypeId)) {
        return false;
      }
    }
    return true;
  }
  function updatePrices(fee, priceElements) {
    const prices = document.querySelectorAll(priceElements);

    prices.forEach(price => {
      if (price.dataset.feeApplied === "true") return;

      let rawValue = price.tagName === "INPUT"
        ? price.value
        : price.textContent;

      const numericValue = parseFloat(rawValue.replace('£', ''));

      if (isNaN(numericValue) || numericValue === 0) return;

      const newPrice = numericValue + fee;

      const formatted = `£${newPrice.toFixed(2)}`;

      if (price.tagName === "INPUT") {
        price.value = formatted;
      } else {
        price.textContent = formatted;
      }
      
      price.dataset.feeApplied = "true";
    });
  }
  function updateDOM(message) {
    const element = document.querySelector(message.selector);
    const tag = document.createElement(message.tag);
    if (element && tag) {
      tag.classList = message.classes;
      tag.append(message.text);
      if (message.after) {
        element.after(tag);
      } else {
        element.before(tag);
      }
    }
  }
  const DEFAULTS = {
    fee: 3,
    text: "Including £3 per order transaction fee",
    tag: "span",
    classes: ["c-booking-fee"],
    after: true,
    modesOfSale: [3, 13, 20, 26, 27, 32, 35, 36, 38, 41, 45, 46, 47, 48, 51, 52, 53, 55, 56, 57, 58, 59, 60, 61, 64],
    observerConfig: {
      attributes: true,
      attributeFilter: ["class"],
      attributeOldValue: true,
    },
    observerDisconnect: false,
    rules: function (message) {
      return isPage(message.pathname) && isFeeApplicable(message);
    },
  };
  let lastSubtotal = null;
  const MESSAGES = [
    {
      // booking fee below price list buttons in "Choose the best available tickets for me"
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".tn-ticket-selector__pricetype-selector",
      pricesElements: '.tn-ticket-selector__pricetype-container:not([style*="display: none"]) .tn-ticket-selector__fixed-amount-input',
      mutation: "body",
      observerConfig: {
        attributes: true,
        subtree: true,
      },
      text: function (message, _observer, _mutationElement, mutationList) {
        const text = document.querySelector(
          ".tn-ticket-selector__controls-container .c-booking-fee",
        );
        if (text) text.remove();

        const priceTypes = document.querySelectorAll(
          '.tn-ticket-selector__pricetype-container:not([style*="display: none"]) .tn-ticket-selector__pricetype',
        );

        const priceTypeIds = Array.from(priceTypes).map((item) => {
          return parseInt(item.dataset.tnPriceTypeId);
        });

        const hasNonExemptPriceTypes = priceTypeIds.some(
          (id) => !CONFIG.priceTypeExceptions.includes(id),
        );
        updateDOM({
            ...message,
            text: "Plus a £3 per order transaction fee. Standing and free tickets exempt from booking fee",
          });
      },
    },
    {
      // 'no booking fee' below price list buttons in "Choose the best available tickets for me"
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".tn-ticket-selector__pricetype-selector",
      pricesElements: '.tn-ticket-selector__pricetype-container:not([style*="display: none"]) .tn-ticket-selector__fixed-amount-input',
      mutation: "body",
      observerConfig: {
        attributes: true,
        subtree: true,
      },
      observerDisconnect: true,
      modesOfSale: [14, 15, 18, 19, 28, 29, 37, 42],
      text: currentModeOfSale() === 15 ? "Best Friends and Patrons book without transaction fees" : "No booking fee",
    },
    {
      // booking fee below price list buttons in seat selection modal
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".modal .tn-syos-seat-info__price-type-list",
      pricesElements: ".modal .tn-syos-seat-info__price-type-price",
      mutation: "body",
      text: function (message, _observer, _mutationElement, mutationList) {
        for (const mutation of mutationList) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class" &&
            !mutation.oldValue?.split(" ").includes("modal-open") &&
            mutation.target.classList.contains("modal-open")
          ) {
            listenForSeatSelection();
            if (availablePricesAreExempt()) return;
            updateDOM({
              ...message,
              text: "Plus a £3 per order transaction fee",
            });
          }
        }
      },
    },
    {
      // 'no booking fee' below price list buttons in seat selection modal for certain member MOS
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".modal .tn-syos-seat-info__price-type-list",
      mutation: "body",
      modesOfSale: [14, 15, 18, 19, 28, 29, 37, 42],
      text: function (message, _observer, _mutationElement, mutationList) {
        for (const mutation of mutationList) {
          if (
            mutation.type === "attributes" &&
            mutation.attributeName === "class" &&
            !mutation.oldValue?.split(" ").includes("modal-open") &&
            mutation.target.classList.contains("modal-open")
          ) {
            updateDOM({
              ...message,
              text: currentModeOfSale() === 15 ? "Best Friends and Patrons book without transaction fees" : "No booking fee",
            });
          }
        }
      },
    },
    {
      // booking fee below price list in 'view selected seats' modal
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".modal .tn-syos-cart__summary",
      pricesElements: ".modal .tn-syos-cart__summary-value",
      mutation: "body",
      observerConfig: {
        childList: true,
        subtree: true
      },
      text: function (message, _observer, _mutationElement, mutationList) {
        const text = document.querySelector(
          ".tn-syos-cart-modal .c-booking-fee",
        );
        if (text) text.remove();
        if (selectedPriceTypesAreExempt()) return;
        updatePrices(message.fee, message.pricesElements);
        updateDOM({
          ...message,
          text: DEFAULTS.text,
        });
      },
    },
    {
      // booking fee message on the prices sidebar list
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".modal .tn-syos-legend__zone-list .tn-syos-legend__description-group:last-of-type",
      mutation: "body",
      text: function (message, _observer, _mutationElement, mutationList) {
        const text = document.querySelector(
          ".modal .tn-syos-legend__zone-list .c-booking-fee",
        );
        if (text) return;
        updateDOM({
          ...message,
          text: "Plus a £3 per order transaction fee",
        });
      },
    },
    {
      // booking fee message on the prices sidebar list
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".tn-syos-legend__desktop-container .tn-syos-legend__description-group:last-of-type",
      mutation: "body",
      text: function (message, _observer, _mutationElement, mutationList) {
        const text = document.querySelector(
          ".tn-syos-legend__desktop-container .c-booking-fee",
        );
        if (text) return;
        updateDOM({
          ...message,
          text: "Plus a £3 per order transaction fee",
        });
      },
    },
    {
      // 'no booking fee' below price list in 'view seats' modal for certain member MOS
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".modal .tn-syos-cart__summary",
      mutation: "body",
      text: currentModeOfSale() === 15 ? "Best Friends and Patrons book without transaction fees" : "No booking fee",
      modesOfSale: [14, 15, 18, 19, 28, 29, 37, 42],
    },
    {
      // 'booking fee' on SYOS total (below map)
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".tn-syos-mobile-cart-controls__summary-subtotal",
      pricesElements: ".tn-syos-mobile-cart-controls__summary-subtotal",
      mutation: ".tn-syos-mobile-cart-controls__summary",
      observerConfig: {
        childList: true,
        subtree: true
      },
      text: function (message) {
        setTimeout(() => {
          updateSelectedPriceTypes();
          const subtotalEl = document.querySelector(
            ".tn-syos-mobile-cart-controls__summary-subtotal"
          );
          if (!subtotalEl) return;
          const currentValue = subtotalEl.textContent.trim();
          if (currentValue === lastSubtotal) return;
          document.querySelector(".tn-syos-mobile-cart-controls__summary-subtotal").dataset.feeApplied = "false";
          const feeInfo = document.querySelector("#tn-syos-cart-summary .c-booking-fee");
          if (feeInfo) feeInfo.remove();
          if (selectedPriceTypesAreExempt()) return;
          updatePrices(message.fee, message.pricesElements);
          lastSubtotal = subtotalEl.textContent.trim();
          if (parseFloat(lastSubtotal.replace('£', '')) > 0) {
              updateDOM({
              ...message,
              text: DEFAULTS.text,
            });
          }
        }, 5);
      }
    },
    {
      // 'no booking fee' on SYOS total (below map) for certain member MOS
      pathname: /^\/\d+(?:\/\d+)?(?:\?.*)?$/,
      selector: ".tn-syos-mobile-cart-controls__summary-subtotal",
      mutation: ".tn-syos-mobile-cart-controls__summary",
      observerConfig: {
        childList: true,
        subtree: true
      },
      observerDisconnect: true,
      modesOfSale: [14, 15, 18, 19, 28, 29, 37, 42],
      text: currentModeOfSale() === 15 ? "Best Friends and Patrons book without transaction fees" : "No booking fee",
    },
  ];
  const callback = function (message) {
    message = { ...DEFAULTS, ...message };
    if (message.mutation) {
      const mutationElement = document.querySelector(message.mutation);
      if (!mutationElement) return;
      let observer;
      const callback = (mutationList, observer) => {
        // A little delay is added to allow TNEW to add the new DOM element
        setTimeout(() => {
          if (!message.rules(message)) return;
          if (document.querySelector(message.selector)) {
            if (typeof message.text === "function") {
              message.text(message, observer, mutationElement, mutationList);
            } else {
              updateDOM(message);
            }
            if (message.observerDisconnect) observer.disconnect();
          }
        }, 10);
      };
      observer = new MutationObserver(callback);
      observer.observe(mutationElement, message.observerConfig);
    } else {
      if (!message.rules(message)) return;
      if (typeof message.text === "function") {
        message.text(message, null, null, null);
      } else {
        updateDOM(message);
      }
    }
  };
  setTimeout(() => {
    MESSAGES.forEach((message) => {
      callback(message);
    });
  }, 300);
})();
